/**
 * Compact freshness stamp for "updated at" lines: just the time when the moment is today
 * (local), the full date and time otherwise. Use formatTimestamp where the exact date matters.
 */
export function formatWhen(date: Date | null, now: Date = new Date()): string {
  if (!date || Number.isNaN(date.getTime())) return "—";
  const today = date.toDateString() === now.toDateString();
  return today
    ? date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleString(undefined, {
        dateStyle: "short",
        timeStyle: "short",
      });
}
